import { take } from 'lodash'
import { Col, Row } from 'antd'
import { useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLocationDot } from '@fortawesome/pro-solid-svg-icons'

import { ColorsPalette } from '../../../config/colors'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import EntityBadge from '../Badges/EntityBadge'

const ACRONYM_MAX_LENGTH = 5
const NO_DATA = '/'

const ELLIPSIS = { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }

const BADGE_STYLE = { marginRight: '5px' }

const ACRONYM_TILE_STYLE = {
  width: '45px',
  height: '45px',
  backgroundColor: ColorsPalette.LIGHTER_GREY,
  borderRadius: '10px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: '3px'
}

const ACRONYM_STYLE = {
  fontWeight: 900,
  fontSize: '10px',
  color: ColorsPalette.GREY,
  WebkitTextStroke: '0.5px currentColor'
}

const DETAILS_STYLE = { width: 'calc(100% - 52px)' }

const ROW_STYLE = { height: '20px' }

const NAME_STYLE = {
  ...ELLIPSIS,
  marginLeft: '5px',
  fontSize: '.75rem',
  color: ColorsPalette.FIRST,
  WebkitTextStroke: '0.1px currentColor'
}

const LOCATION_STYLE = { ...ELLIPSIS, marginLeft: '5px', fontSize: '.75rem', color: ColorsPalette.GREY }

export const getEntityAddress = entity => {
  const locality = [entity.zipcode, entity.city].filter(Boolean).join(' ')

  return [entity.address, locality].filter(Boolean).join(' - ')
}

/**
 * Institutions and schools share the very same dropdown option layout : category badge, acronym tile,
 * then name and location. Only the property carrying the acronym differs between the two.
 */
const EntityOptionDisplayer = ({ entity }) => {
  const t = useSelector(selectTranslate)

  const acronym = entity.acronym ?? entity.abbreviation ?? ''
  const country = entity.country ? t(entity.country.name) : NO_DATA

  return (
    <div className='entity-option-displayer flex-row ai-ctr w-100'>
      <div style={BADGE_STYLE}><EntityBadge entity={entity} size='xl' /></div>
      <Col className='mr-4'>
        <div style={ACRONYM_TILE_STYLE}>
          <span style={ACRONYM_STYLE}>{take(acronym, ACRONYM_MAX_LENGTH)}</span>
        </div>
      </Col>
      <Col style={DETAILS_STYLE}>
        <Row style={{ ...ROW_STYLE, ...ELLIPSIS }}>
          <span style={NAME_STYLE}>
            <strong className='ml-4'>{entity.name}</strong>
          </span>
        </Row>
        <Row style={{ ...ROW_STYLE, ...ELLIPSIS }}>
          <span className='flex-row ai-ctr w-100' style={ELLIPSIS}>
            <FontAwesomeIcon icon={faLocationDot} color={ColorsPalette.GREY} size='sm' style={{ marginLeft: '1px' }} />
            <span style={LOCATION_STYLE}>{`${getEntityAddress(entity)} - ${country}`}</span>
          </span>
        </Row>
      </Col>
    </div>
  )
}

export default EntityOptionDisplayer
